/** Ninja API responses are wrapped as `{ error: boolean, data: T }`. */
export function unwrapApiResponse<T>(payload: unknown): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return (payload as { data: T }).data;
  }
  return payload as T;
}
